import React, { FunctionComponent, useCallback } from "react";
import styles from "./Header3.module.scss";
import Header3Props from "./Header3Props.interface";

import { CLOSE_ALL_OVERLAYS, OPEN_MENU } from "layout/redux/overlay.actions";
import { useDispatch, useSelector } from "react-redux";
import combineClasses from "helpers/combine-classes";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import MenuOverlay from "./components/MenuOverlay/MenuOverlay";
import setHeaderStyles from "./hooks/setHeaderStyles";
import Anchor from "components/Anchor/Anchor";

const Header3: FunctionComponent<Header3Props> = (props) => {
    const overlay = useSelector(state => state.overlay);

    let header: any;
    if (props?.theme?.header?.[0] && props?.theme?.header.length > 0) {
        header = props?.theme?.header[0]?.content;
    }

    const dispatch = useDispatch();
    const headerStyles = setHeaderStyles(header);

    const page = useSelector(state => state.page.content);

    const imageAspectRatio = getImageAspectRatio(undefined, header?.logo?.umbracoWidth, header?.logo?.umbracoHeight);
    const overlayActiveClass = overlay.currentOverlay === "MENU" ? styles.is_active : undefined;

    const toggleMenu = useCallback((event: any) => {
        if (event) {
            event.stopPropagation();
        }

        if (overlay?.currentOverlay === "MENU") {
            dispatch({
                type: CLOSE_ALL_OVERLAYS
            });
        }
        else {
            dispatch({
                type: OPEN_MENU
            });
        }
    }, [overlay.currentOverlay]);

    return (
        <header className={styles.wrapper} style={headerStyles}>
            <div className={styles.inner}>
                {header?.logo ? (
                    <Anchor className={styles.image_link} to={page?._homeNodeUrl}>
                        <ImageViewer className={combineClasses(styles.image, overlayActiveClass)} src={header.logo.umbracoFile.src} extensionType="png" type="containY" aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    </Anchor>
                ) : null}

                <button className={combineClasses(styles.menu_toggle_button, overlayActiveClass)} onClick={(event) => toggleMenu(event)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>

            {overlay.currentOverlay === "MENU" ? (
                <MenuOverlay header={header} menu={props.menu} dispatch={dispatch} />
            ) : null}
        </header>
    );
};

export default Header3;